import { request } from "../../backend";
import User, { UserType } from "../../models/User";

/**
 * Fetches all users.
 */
export async function fetchUsers(): Promise<User[]> {
  const users = await request('/users-v1', 'get', null, null, { api: 'users' });

  return users;
}

type App = {
  name: string;
  href: string;
}

export function getAppPermission(user: User) {

  if (user.organizationId !== "68a5f9f07aef05cf6ee0a159" && user.organizationId !== "6862579b2cb8d0a855888243") {
    return {
      isCurrentAppUsable: false,
    }
  }
  
  if (user.type === UserType.Admin || user.type === UserType.Standard) {
    return {
      isCurrentAppUsable: true,
    }
  }

  if (!user.teamId) {
    return {
      isCurrentAppUsable: false
    }
  }

  const apps: { [teamId: string]: App } = {
    '616810a03358f70027f1bca4': { name: 'p94.lingon.se', href: 'https://p94.lingon.se' }, // prod: P94 Sales
    '6154947c704c0700276dfc82': { name: 'mycall.lingon.se', href: 'https://mycall.lingon.se' }, // prod: Mycall
    '6127e370dfb69300278e9a90': { name: 'åf.lingon.se', href: 'https://xn--f-1fa.lingon.se' }, // prod: Ligum
    '6154924b704c0700276df09a': { name: 'sälj.lingon.se', href: 'https://xn--slj-qla.lingon.se' }, // prod: Inhouse
    '62209dad2ce6060028fdb078': { name: 'sälj.lingon.se', href: 'https://xn--slj-qla.lingon.se' }, // prod: Lejonen
    '621e1fae2ce6060028e8c8be': { name: 'sälj.lingon.se', href: 'https://xn--slj-qla.lingon.se' }, // prod: Ofelia
    '621e21d72ce6060028e8f068': { name: 'sälj.lingon.se', href: 'https://xn--slj-qla.lingon.se' }, // prod: Ljusdal Sales
    '621e1fc02ce6060028e8ca24': { name: 'sälj.lingon.se', href: 'https://xn--slj-qla.lingon.se' }, // prod: Björkemo Sales
    '61801e178df84f0028b2f70d': { name: 'tellme.lingon.se', href: 'https://tellme.lingon.se' }, // prod: Tellme
    '619518131e3f150028da60a8': { name: 'alvascc.lingon.se', href: 'https://alvascc.lingon.se' }, // prod: Alvas Callcenter
    '619cb7b3c3d6d70027682394': { name: 'empire.lingon.se', href: 'https://empire.lingon.se' }, // prod: Empire of Sales
    '61d288939b471900284c910e': { name: 'daniel.lingon.se', href: 'https://daniel.lingon.se' }, // prod: TEAM Danne
    '61d288b29b471900284c9150': { name: 'adam.lingon.se', href: 'https://adam.lingon.se' }, // prod: TEAM Adam
    '61d2888e9b471900284c9101': { name: 'olsson.lingon.se', href: 'https://olsson.lingon.se' }, // prod: TEAM Olsson
    '61d288a49b471900284c9134': { name: 'josef.lingon.se', href: 'https://josef.lingon.se' }, // prod: TEAM Josef
    '61dc2ba042fb9d0028389285': { name: 'ace.lingon.se', href: 'https://ace.lingon.se' }, // prod: ACE Consulting
    '61df363142fb9d00284bf657': { name: 'cbt.lingon.se', href: 'https://cbt.lingon.se' }, // prod: CBT
    '61e6f29142fb9d00286b67d6': { name: 'k2s.lingon.se', href: 'https://k2s.lingon.se' }, // prod: KEY2SALES KARLSTAD
    '620144f473e267002c4c2120': { name: 'k2s.lingon.se', href: 'https://k2s.lingon.se' }, // prod: KEY2SALES STHLM
    '6201450d73e267002c4c23e6': { name: 'k2s.lingon.se', href: 'https://k2s.lingon.se' }, // prod: KEY2SALES DISTANS
    '6201453873e267002c4c286e': { name: 'aldovo.lingon.se', href: 'https://aldovo.lingon.se' }, // prod: Aldovo
    '60f0221f741e2600268b63db': { name: 'sälj.lingon.elipt.is', href: 'https://xn--slj-qla.lingon.elipt.is' }, // test: team1
    '60eaedb4d609ea421fb9eaf4': { name: 'sälj.lingon.elipt.is', href: 'https://xn--slj-qla.lingon.elipt.is' }, // test: Säljare
    '65fc72c1b01af71cbad42454': { name: 'abonnix.lingon.se', href: 'https://abonnix.lingon.se' }, // prod: HeyCom (eller Abonnix)
    '65fc72ef9628861cb764438f': { name: 'abonnix.lingon.se', href: 'https://abonnix.lingon.se' }, // prod: HeyCom ÅF Chef (eller Abonnix ÅF Chef)
    '65fc703ab01af71cbad42435': { name: 'dingo.lingon.se', href: 'https://dingo.lingon.se' }, // prod: Dingo
    '65fc71eeb01af71cbad42447': { name: 'dingo.lingon.se', href: 'https://dingo.lingon.se' }, // prod: Dingo ÅF Chef
    '66c884ac876492906933331d': { name: 'paul.lingon.se', href: 'https://paul.lingon.se' }, // prod: TEAM PAUL
    '66c88494876492906933331b': { name: 'alice.eddie.lingon.se', href: 'https://alice.eddie.lingon.se' }, // prod: TEAM ALICE & EDDIE
  };

  const teamIds: string[] = [];
  if (user.teamId) {
    teamIds.push(user.teamId);
  }

  user.supervisedTeamIds?.forEach(teamId => teamIds.push(teamId));

  //  Vi använder <subdomän>.lingon.salesys.se ifall vi inte kan ändra i lingon.se DNS.
  let origin = document.location.origin.replace('.salesys.se', '.se');

  if (document.location.hostname === "alice.eddie.salesys.se") {
    origin = "https://alice.eddie.lingon.se";
  }

  for (const teamId in apps) {
    const app = apps[teamId];
    if (teamIds.includes(teamId) && app.href === origin) {
      return {
        isCurrentAppUsable: true,
        app
      };
    }
  }

  return {
    isCurrentAppUsable: false,
    app: null
  }
}